/**
 *   Generated file. Do not edit
 */

import { FirmwareState } from './models';
import { FirmwareUpdateResult } from './models';
import { CrcCheckBody } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  postPackage: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/firmware/package',
    path: '/5//0',
  } as ServiceCallType<void, void>,

  postUpdate: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/firmware/update',
    path: '/5//2',
  } as ServiceCallType<void, void>,

  getState: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/firmware/state',
    path: '/5//3',
    responseBodyDecoder: allConverters.firmwareState,
  } as ServiceCallType<void, FirmwareState>,

  getUpdateResult: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/firmware/update-result',
    path: '/5//5',
    responseBodyDecoder: allConverters.firmwareUpdateResult,
  } as ServiceCallType<void, FirmwareUpdateResult>,

  postCrcCheck: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/firmware/crc-check',
    path: '/5//6',
    bodyEncoder: allConverters.crcCheckBody,
  } as ServiceCallType<CrcCheckBody, void>,
};
